import React, { Component } from 'react'
import { connect } from 'react-redux'

import '@/companys/eif/assets/styles/components/copy-right/copy-right.scss'

class CopyRight extends Component {
  render() {
    const { language } = this.props
    return (
      <footer className='copy-right'>
        <p>{language.common_copyright}</p>
      </footer>
    )
  }
}

export default connect(state => ({ language: state.app.language }))(CopyRight)
